import { render, staticRenderFns } from "./GastosProyecto.vue?vue&type=template&id=05b2c4d2"
import script from "./GastosProyecto.vue?vue&type=script&lang=js"
export * from "./GastosProyecto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports